import { sessionStorageKeeperService } from '@/shared/auth-service';
import axios from 'axios';

const urlPostfix = '/api/manager';
// These APIs return Promise objects.

class NsmReportingApi {

  deleteNsmScheduleReport(baseUrl:string, scheduleId: any) {
    return axios.delete(`${baseUrl}${urlPostfix}/reportconfig/taskconfig?source=2&view=2`, {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('nsmToken'),
      },
      params: { id: scheduleId },
    });
  }

  deleteNsmArchivedReport(baseUrl:string, id: any) {
    return axios.delete(`${baseUrl}${urlPostfix}/reportconfig/archivedreportlist`, {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('nsmToken'),
      },
      params: { scheduleTaskId: id },
    });
  }

  downloadNsmArchivedReport(baseUrl:string, id: any, view : any) {
    return axios.get(`${baseUrl}${urlPostfix}/reportconfig/archivedreports`, {
      headers: {
        authorization: sessionStorageKeeperService.retrieve('nsmToken'),
      },
      params: { id, view, source : 2 },
    });
  }
}

export const nsmReportingApi = new NsmReportingApi();
